import { withOktaAuth } from "@okta/okta-react"
import onboarding from 'assets/images/onboarding.png'
import FormModal from 'components/organisms/FormModal/FormModal'
import SessionConst from 'constants/SessionConst'
import StringConst from "constants/StringConst"
import { isEmptyObject } from 'jquery'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { getSessionItem, setSessionItem } from 'utilities/SessionHelper'
import * as ErrorConst from '../../constants/ErrorConst'
import * as FormConst from '../../constants/FormConst'
import { FORM_SEARCH_HOTEL_NAME } from '../../constants/FormConst'
import * as RoleConfigurationConst from '../../constants/RoleConfigurationConst'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import { getRequestor, getTrackingId } from '../../utilities/FormHelper'
import { isArrayIncludesAny, isArrayNotEmpty, removeHotelInfoFromSession, removeHotelOnboardingStatusFromSession, removeLockStatusFromSession } from '../../utilities/JSUtil'
import Button from '../atoms/Button/Button'
import Table from '../molecules/Table/Table'
import DashboardSummary from './DashboardSummary'
import './SearchHotel.scss'

class SearchHotel extends Component {

    constructor(props) {
        super(props)

        this.searchHotel = this.searchHotel.bind(this)
        this.handleHotelCodeChange = this.handleHotelCodeChange.bind(this)
        this.searchHotel = this.searchHotel.bind(this)
        this.redirectToAdmin = this.redirectToAdmin.bind(this)
        this.redirectToTermsAndConditions = this.redirectToTermsAndConditions.bind(this)

        this.state = {
            hotelCode: '',
            onboardingHotelsList: [],
            errorMessage: undefined,
            isLoading: false,
            user: {}
        }
        removeHotelInfoFromSession()
        removeLockStatusFromSession()
        removeHotelOnboardingStatusFromSession()
    }

    handleAuthentication = async () => {

        const oktaAuth = this.props.oktaAuth

        if (oktaAuth) {

            const authStateManager = oktaAuth.authStateManager
            const authState = authStateManager.getAuthState()

            const authenticated = authState.isAuthenticated
            if (authenticated) {
                const accessToken = authState.accessToken
                const userInfo = await oktaAuth.token.getUserInfo()

                // Determines if the user is an admin or not and saves the property id list
                const user = this.processUserRole(accessToken.claims.jobRole, accessToken.claims.propelRole, accessToken.claims.hrpmRole, accessToken.claims.propertyID, userInfo.name, userInfo['given_name'],
                    userInfo['family_name'], userInfo['preferred_username'])
                if (!getSessionItem(SessionConst.TRACKING_ID)) {
                    setSessionItem(SessionConst.TRACKING_ID, getTrackingId())
                }
                if (!getSessionItem(SessionConst.REQUESTOR)) {
                    setSessionItem(SessionConst.REQUESTOR, getRequestor(userInfo))
                }

                this.setState({
                    user: user
                })
            } else {
                this.setState({
                    showRefreshTokenModal: true
                })
            }
        }
    }

    processUserRole(jobRoles = [], propelRoles = [], hrpmRoles = [], propertyList = [], userFullName = '', firstName = '', lastName = '', username = '') {
        let user = {
            jobRoles: jobRoles,
            propelRoles: propelRoles,
            hrpmRoles: hrpmRoles,
            isAdmin: false,
            isFranchiseCareUser: false,
            isOpeningServicesUser: false,
            isHotelContact: false,
            isReadOnlyUser: true,
            isAccessAllProperties: propertyList.length === 1 && propertyList[0] === 'ALL',
            propertyList: propertyList,
            fullname: userFullName,
            firstName: firstName,
            lastName: lastName,
            username: username
        }

        /*
        1. If the user doesn't have any propel role then send them to the error page.
        2. If the user has READ_ONLY_PROPEL_ROLE then make them a read only user and stop further checks.
        3. If the user does not have READ_ONLY_PROPEL_ROLE or FULL_ACCESS_PROPEL_ROLE, then send them to the error page.
        4. If the user has FULL_ACCESS_PROPEL_ROLE but no job roles then send them to the error page.
        5. If the user has FULL_ACCESS_PROPEL_ROLE then make them read-write. If the user has ADMIN_ROLES then make them an admin user.
        6. If the user has FULL_ACCESS_PROPEL_ROLE then make them read-write. If the user does not have ADMIN_ROLES then make them a non admin user.

        No. | Propel Role                     | Job Role          | Access        | Is Admin
        ------------------------------------------------------------------------------------
        1   | No roles                        | *                 | Error         | No
        2   | READ_ONLY_PROPEL_ROLE           | *                 | Read only     | No
        3   | Not READ_ONLY_PROPEL_ROLE       | *                 | Error         | No
            | or FULL_ACCESS_PROPEL_ROLE      |
        4   | FULL_ACCESS_PROPEL_ROLE         | No roles          | Error         | No
        5   | FULL_ACCESS_PROPEL_ROLE         | ADMIN_ROLES       | Read write    | Yes
        6   | FULL_ACCESS_PROPEL_ROLE         | Non ADMIN_ROLES   | Read write    | No
        */

        // 1. If the user doesn't have any propel role, then send them to the error page.
        if (!isArrayNotEmpty(propelRoles)) {
            this.redirectToErrorPage(user)
        }

        // 2. If the user has READ_ONLY_PROPEL_ROLE, then make them a read only user and stop further checks.
        if (isArrayIncludesAny(propelRoles, [RoleConfigurationConst.READ_ONLY_PROPEL_ROLE])) {
            user.isReadOnlyUser = true
        } else {
            // 3. If the user does not have READ_ONLY_PROPEL_ROLE or FULL_ACCESS_PROPEL_ROLE, then send them to the error page.
            const isFullAccessUser = isArrayIncludesAny(propelRoles, [RoleConfigurationConst.FULL_ACCESS_PROPEL_ROLE])

            if (!isFullAccessUser) {
                this.redirectToErrorPage(user)
            }

            // 4. If the user has FULL_ACCESS_PROPEL_ROLE but no job roles then send them to the error page.
            if (!isArrayNotEmpty(jobRoles)) {
                this.redirectToErrorPage(user)
            }

            // 5. If the user has FULL_ACCESS_PROPEL_ROLE then make them read-write. If the user has ADMIN_ROLES then make them an admin user.
            // 6. If the user has FULL_ACCESS_PROPEL_ROLE then make them read-write. If the user does not have ADMIN_ROLES then make them a non admin user.
            user.isReadOnlyUser = false

            if (isArrayIncludesAny(jobRoles, RoleConfigurationConst.ADMIN_ROLES)) {
                user.isAdmin = true
                user.isFranchiseCareUser = jobRoles.includes(RoleConfigurationConst.FRANCHISE_CARE_ROLE)
                user.isOpeningServicesUser = jobRoles.includes(RoleConfigurationConst.OPENING_SERVICES_ROLE)
            } else {
                user.isAdmin = false
                user.isFranchiseCareUser = false
                user.isOpeningServicesUser = false
                user.isHotelContact = isArrayIncludesAny(jobRoles, RoleConfigurationConst.HOTEL_CONTACT_ROLES)
            }
        }

        // Set the user object in the session
        setSessionItem(SessionConst.USER, user)
        return user
    }

    async componentDidMount() {
        if (this.props.authState.isAuthenticated) {
            this.handleAuthentication()
        }
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.SEARCH) {
                // This means we searched for onboarding status
                if (this.props.errorMessage) {
                    // Error during search
                    if (ErrorConst.ERRORS_CODES_NO_ASSOCIATED_APPLICATIONS.includes(this.props.errorMessage)) {
                        this.setState({ isLoading: false, errorMessage: 'No onboarding applications associated with this hotel' })
                    } else if (this.props.errorMessage === ErrorConst.ERROR_CODE_HOTEL_READY_FOR_ONBOARDING) {
                        if (this.state.user.isHotelContact) {
                            // Invalid status in HDS means there is no existing application. Only hotel owners can create a new application
                            this.redirectToTermsAndConditions()
                        } else if (this.state.user.isAdmin) {
                            // Show admins a link to the Hotel Contact page
                            this.setState({
                                isLoading: false,
                                errorMessage: <>
                                    Onboarding not initiated by Hotel Contact
                                    <br />
                                    <Button
                                        id='update-hotel-contact-details-button'
                                        name={`Update ${FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR} details`}
                                        role='link'
                                        onClick={this.redirectToHotelContactPage} />
                                </>
                            })
                        } else {
                            this.setState({ isLoading: false, errorMessage: 'Onboarding not initiated by Hotel Contact' })
                        }
                    } else {
                        this.setState({ isLoading: false, errorMessage: 'Error retrieving data. Tracking id: ' + getSessionItem(SessionConst.TRACKING_ID) })
                    }
                } else {
                    // Search successful
                    if (this.state.user.isHotelContact) {

                        if (this.props.onboardingStatus.assignedTo === undefined
                            || this.props.onboardingStatus.assignedTo === this.state.user.username) {
                            // User has the lock

                            // If terms and conditions are missing from Onboarding status then redirect them to Terms and Conditions page
                            if (isEmptyObject(this.props.onboardingStatus.termsConditions)) {
                                this.redirectToTermsAndConditions()
                            } else if (this.props.onboardingStatus.status === FormConst.STATUS_GENERATED) {
                                // If the onboarding status is GENERATED, direct the Hotel Contact to the UpdateOnboarding page
                                // Only hotel owners can begin onboarding
                                this.redirectToUpdateOnboarding(FormConst.ACTION_START_APPLICATION)
                            } else {
                                this.redirectToLaunchOnboardingApplication()
                            }
                        } else {
                            //User doesn't have the lock
                            if (FormConst.STATUS_LIST_HOTEL_OWNER_EDIT.includes(this.props.onboardingStatus.status)) {
                                // Show the acquire lock modal
                                this.setState({
                                    isUpdateLock: true,
                                    isLoading: false,
                                    onboardingStatus: this.props.onboardingStatus
                                })
                            } else {
                                this.redirectToLaunchOnboardingApplication()
                            }
                        }
                    } else if (this.state.user.isAdmin) {

                        if (this.props.onboardingStatus.status === FormConst.STATUS_GENERATED) {
                            // Redirect to Update Onboarding page
                            this.redirectToUpdateOnboarding(FormConst.ACTION_START_APPLICATION)
                        } else if (this.props.onboardingStatus.status === FormConst.STATUS_READY_FOR_REVIEW) {
                            // Admins have the option to change the status to in review or just view the application
                            this.redirectToUpdateOnboarding(FormConst.ACTION_START_REVIEW)
                        } else {
                            this.redirectToLaunchOnboardingApplication()
                        }
                    } else {
                        this.redirectToLaunchOnboardingApplication()
                    }
                }
            } else if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.ACQUIRE_USER) {
                // Only a hotel contact can reach this code
                if (this.props.errorMessage) {
                    // Could not acquire lock
                    this.setState({ isUpdateLock: false, errorMessage: 'Could not acquire lock' })
                } else {
                    // Acquired lock, redirect to launch onboarding
                    // Update the onboarding record assignment
                    let updatedOnboardingStatus = {
                        ...this.state.onboardingStatus,
                        assignedTo: this.state.user.username
                    }
                    // If terms and conditions are missing from Onboarding status then redirect them to Terms and Conditions page
                    if (isEmptyObject(updatedOnboardingStatus.termsConditions)) {
                        this.redirectToTermsAndConditions(updatedOnboardingStatus)
                    } else if (updatedOnboardingStatus.status === FormConst.STATUS_GENERATED) {
                        // If the onboarding status is GENERATED, direct the Hotel Contact to the UpdateOnboarding page
                        // Only hotel owners can begin onboarding
                        this.redirectToUpdateOnboarding(FormConst.ACTION_START_APPLICATION, updatedOnboardingStatus)
                    } else {
                        this.redirectToLaunchOnboardingApplication(updatedOnboardingStatus)
                    }
                }
            }
        } else if (JSON.stringify(prevProps.authState) !== JSON.stringify(this.props.authState)) {
            this.handleAuthentication()
        }
    }

    handleHotelCodeChange = (event) => {
        this.setState({
            hotelCode: event.target.value?.trim().toUpperCase()
        })
    }

    searchHotel = async () => {
        // If there is no hotel code, throw error
        if (!this.state.hotelCode) {
            this.setState({ errorMessage: 'Please enter a hotel code' })
            return
        }
        // If the user does not have access to all properties, validate hotel code against property list before searching
        if (!this.state.user.isAccessAllProperties && (!this.state.user.propertyList || this.state.user.propertyList.indexOf(this.state.hotelCode) === -1)) {
            this.setState({ errorMessage: `The hotel '${this.state.hotelCode}' is not associated with this account` })
            return
        }
        // Get the onboarding status for the hotel
        this.props.onSearchOnboardingStatus(this.state.hotelCode)
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_SEARCH_HOTEL_TEXT, errorMessage: undefined, onboardingStatus: undefined })
    }

    redirectToErrorPage = (user) => {
        this.props.history.push(RouteConst.ROUTE_USER_ERROR_PAGE, {
            user: user
        })
    }

    redirectToAdmin = () => {
        this.props.history.push(RouteConst.ROUTE_ADMIN_PAGE);
    }

    redirectToHotelContactPage = () => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_ONBOARDING_CONTACT_INITIAL,
            state: {
                hotelCode: this.state.hotelCode
            }
        })
    }

    redirectToTermsAndConditions = (onboardingStatus) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_TERMS_AND_CONDITIONS_PAGE,
            state: {
                hotelCode: this.state.hotelCode,
                onboardingStatus: !!onboardingStatus ? onboardingStatus : this.props.onboardingStatus
            }
        })
    }

    redirectToHistorySearch = () => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_HISTORY_SEARCH_PAGE,
            state: {
                hotelCode: this.state.hotelCode
            }
        })
    }

    redirectToLaunchOnboardingApplication = (onboardingStatus) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE,
            state: {
                hotelCode: this.state.hotelCode,
                onboardingStatus: !!onboardingStatus ? onboardingStatus : this.props.onboardingStatus
            }
        })
    }

    redirectToUpdateOnboarding = (action, onboardingStatus) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_UPDATE_ONBOARDING_PAGE,
            state: {
                hotelCode: this.state.hotelCode,
                onboardingStatus: !!onboardingStatus ? onboardingStatus : this.props.onboardingStatus,
                action: action
            }
        })
    }

    redirectToConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_LAUNCH_CONFIGURE_PAGE)
    }

    render() {

        const searchHotelLabel = <label id='search-page-hotel-code-label'><b>Hotel Code</b></label>
        const searchHotelInput = <input id='search-page-hotel-code-input' className='search-page-hotel-code-input' type='text'
            onChange={this.handleHotelCodeChange}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    this.searchHotel()
                }
            }
            }
            autoComplete='off' />

        let searchHotelFormData
        let searchHotelFormClass

        let searchHotelFormDataSingleRow
        let searchHotelFormClassSingleRow
        const actionLabel = <span></span>

        if (this.state.user.isAdmin) {
            const actionButtons = (
                <div className='action-buttons'>
                    <Button id='search-page-search-button' name='Search' role='action' onClick={this.searchHotel} />
                    <Button id='search-page-admin-page-button' name='Show All' role='action' onClick={this.redirectToAdmin} />
                    <Button id='search-history-admin-page-button' name='Show History' role='action' onClick={this.redirectToHistorySearch} />
                </div>
            )
            let inputRow = [searchHotelLabel, searchHotelInput]
            let actionRow = [actionLabel, actionButtons]
            searchHotelFormData = [inputRow, actionRow]
            searchHotelFormClass = 'search-hotel-form-table'
            searchHotelFormDataSingleRow = undefined
        } else {
            const actionButton = (
                <div className='action-buttons'>
                    <Button id='search-page-search-button' name='Search' role='action' onClick={this.searchHotel} />
                    <Button id='search-page-admin-page-button' name='Show All' role='action' onClick={this.redirectToAdmin} />
                </div>
            )
            let inputRow = [searchHotelLabel, searchHotelInput]
            let actionRow = [actionLabel, actionButton]
            searchHotelFormDataSingleRow = [inputRow, actionRow]
            searchHotelFormClassSingleRow = 'search-hotel-form-table'
            searchHotelFormData = undefined
        }

        return (
            <div className='search-hotel-page'>
                <img id='search-page-logo' src={onboarding} className='onboarding-img' />
                <div className='search-hotel-form'>
                    {this.state.user.fullname && <h4 id='search-page-welcome-message' className='welcome-message'>Welcome to {StringConst.APP_NAME}, {this.state.user.fullname}</h4>}
                    <div className='search-hotel-page-helper-text'>{FormConst.SEARCH_HOTEL_HELPER_TEXT}</div>
                    {searchHotelFormDataSingleRow && <Table id='search-page-table-layout' borderless className={searchHotelFormClassSingleRow} data={searchHotelFormDataSingleRow}></Table>}
                    {searchHotelFormData && <Table id='search-page-table-layout' borderless className={searchHotelFormClass} data={searchHotelFormData}></Table>}

                    {this.state.errorMessage && <p id='search-page-error-message' className='search-hotel-form-error'>{this.state.errorMessage}</p>}
                    {this.state.user.isAdmin && getSessionItem(SessionConst.ACCESS_TOKEN) !== undefined && <DashboardSummary user={this.state.user} />}
                    <div className='configure'>
                        {this.state.user.isAdmin && <Button id='configure-link' name={FormConst.CONFIGURE_BUTTON_TEXT} className='configure-link' role='link' onClick={() => {this.redirectToConfigure()}} />}
                    </div>
                </div>
                <FormModal
                    id='search-page-loading-modal'
                    title={FormConst.MODAL_READ_ACTION_TITLE}
                    body={<h6>{this.state.loadingMessage}</h6>}
                    show={this.state.isLoading}
                    isLoadingIndicator />
                <FormModal
                    id='search-page-update-lock-modal'
                    title={FormConst.MODAL_TITLE}
                    body={
                        <h6>
                            Only one person can have access to edit the {StringConst.APP_NAME} form at any given time.
                            Currently another user has rights to edit this {StringConst.APP_NAME} form.
                            Would you like to regain access to the {StringConst.APP_NAME} Form?<br /><br />
                            (Clicking “Yes” will restrict others from editing the {StringConst.APP_NAME} form while editing capability is returned to you.)
                        </h6>
                    }
                    proceed
                    ={() => {
                        this.props.onAcquireUser(this.state.hotelCode)
                        this.setState({
                            isUpdateLock: false,
                            isLoading: true,
                            loadingMessage: FormConst.MODAL_UPDATE_LOCK_TEXT
                        })
                    }}
                    proceedName={FormConst.VALUE_YES}
                    cancel={
                        () => {
                            this.redirectToLaunchOnboardingApplication(this.state.onboardingStatus)
                        }
                    }
                    cancelName={FormConst.VALUE_NO}
                    show={this.state.isUpdateLock}
                    hideLogo />
            </div>
        )
    }

};

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        onboardingStatus: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSearchOnboardingStatus: (hotelCode) => dispatch(asyncMethod(FORM_SEARCH_HOTEL_NAME, actionTypes.ASYNC_ACTIONS.SEARCH, { hotelCode: hotelCode })),
        onPost: (hotelCode) => dispatch(asyncMethod(FORM_SEARCH_HOTEL_NAME, actionTypes.ASYNC_ACTIONS.POST, { hotelCode: hotelCode })),
        onAcquireUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.ACQUIRE_USER, { hotelCode: hotelCode })),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withOktaAuth(SearchHotel)))